export default class Showtimes {
	constructor(el) {
		this.el = el;
		this.statesSelect = this.el.querySelector(".showtimes__states-form-select");
		this.statesListing = this.el.querySelectorAll(".showtimes__state");

		this.onChangeState = this.onChangeState.bind(this);

		this.statesSelect.addEventListener("change", this.onChangeState);

		const optionOne = this.statesSelect.querySelector(
			".showtimes__states-form-option:nth-child(1)"
		);
		const optionTwo = this.statesSelect.querySelector(
			".showtimes__states-form-option:nth-child(2)"
		);

		if (optionTwo) {
			this.statesSelect.value = optionOne.value;
			this.onChangeState();
		}

		this.fixLineBreaks();
	}

	onChangeState(e) {
		if (this.statesSelect.value == "all") {
			this.showAll();
		} else {
			this.hideAll();

			const item = this.el.querySelector(
				`.showtimes__state[data-state="${this.statesSelect.value}"]`
			);

			if (item) {
				item.classList.add("showtimes__state--visible");
			}
		}
	}

	showAll() {
		for (let state of this.statesListing) {
			state.classList.add("showtimes__state--visible");
		}
	}

	hideAll() {
		for (let state of this.statesListing) {
			state.classList.remove("showtimes__state--visible");
		}
	}

	fixLineBreaks() {
		const visibleStates = this.el.querySelectorAll(
			".showtimes__state"
		);

		for (let state of visibleStates) {
			const tds = state.querySelectorAll("td");

			for (let td of tds) {
				td.innerHTML = td.innerHTML.replace(/\//g, '/\u200B');
			}
		}
	}
}
